import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { navigationService } from '@/services/navigationService'
import type { NavigationItem } from '@/types/navigation'

export const useNavigationStore = defineStore('navigation', () => {
  const items = ref<NavigationItem[]>([])
  const adminItems = ref<NavigationItem[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)
  const lastLoadedAt = ref<string | null>(null)

  const rootSections = computed(() => items.value.filter((item) => item.parent_uuid === null))

  const loadNavigation = async (): Promise<NavigationItem[]> => {
    loading.value = true
    error.value = null

    try {
      const response = await navigationService.fetchNavigation()
      items.value = response.items
      lastLoadedAt.value = new Date().toISOString()
      return response.items
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Failed to load navigation'
      error.value = message
      throw err
    } finally {
      loading.value = false
    }
  }

  const loadAdminNavigation = async (): Promise<NavigationItem[]> => {
    loading.value = true
    error.value = null

    try {
      const response = await navigationService.fetchAdminNavigation()
      adminItems.value = response.items
      return response.items
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Failed to load admin navigation'
      error.value = message
      throw err
    } finally {
      loading.value = false
    }
  }

  const clear = () => {
    items.value = []
    adminItems.value = []
    loading.value = false
    error.value = null
    lastLoadedAt.value = null
  }

  return {
    items,
    adminItems,
    loading,
    error,
    lastLoadedAt,
    rootSections,
    loadNavigation,
    loadAdminNavigation,
    clear,
  }
})
